import React from "react";

import { withErrorBoundary } from "@lululemon/mwa-common";
import { Button } from "@lululemon/ecom-pattern-library-button";
import { BrandStatement } from "@lululemon/ecom-pattern-library-brand-statement";
import { GridContainer } from "@lululemon/ecom-pattern-library-grid-container";

import useLocaleStandard from "../../hooks/useLocaleStandard";
import wmtmUrls from "../v2/breadcrumbs/WMTMUrls";
import useWMTMCategory from "../v2/breadcrumbs/use-WMTM-category";
import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";

const PDPWMTMBannerStatement = () => {
  const userLocale = useLocaleStandard();
  const productCategory = useWMTMCategory();
  const localeText = userLocale === "en_CA" ? "favourite" : "favorite";
  const wmtmUrl = () => {
    const url = wmtmUrls.find(
      (url) => url.category === productCategory && url.locale === userLocale
    );
    if (url) {
      const link = url.url;
      return link.replace(/wmtm/, "wmtm-cta");
    }
    return wmtmUrls?.find(
      (url) => url.category === "WMTM" && url.locale === userLocale
    ).url;
  };

  const desktopImage = {
    maxWidth: 2644,
    src: "https://images.lululemon.com/is/image/lululemon/BrandStatement_Zest_D",
  };
  const mobileImage = {
    maxWidth: 746,
    src: "https://images.lululemon.com/is/image/lululemon/BrandStatement_Zest_M",
  };

  return (
    <GridContainer layout="1 Column - Wide">
      <BrandStatement
        ctaButton={
          <LinkGenerator href={`${wmtmUrl()}`}>
            <Button rel="nofollow">Shop we made too much</Button>
          </LinkGenerator>
        }
        headline={`Score a new ${localeText} fit for your goals`}
        imageProps={desktopImage}
        mobileImageProps={mobileImage}
      />
    </GridContainer>
  );
};

PDPWMTMBannerStatement.displayName = "PDPWMTMBannerStatement";

PDPWMTMBannerStatement.defaultProps = {};

PDPWMTMBannerStatement.propTypes = {};

export default withErrorBoundary({
  componentName: "PDP WMTM Banner Statement",
})(PDPWMTMBannerStatement);
